import React, { useState } from "react";

function NewMovementModal(props) {
    const ottieniDataOdierna = () => {
        const oggi = new Date();
        const anno = oggi.getFullYear();
        const mese = String(oggi.getMonth() + 1).padStart(2, '0');
        const giorno = String(oggi.getDate()).padStart(2, '0');
        return `${anno}-${mese}-${giorno}`;
    };

    // Controlliamo se stiamo modificando un movimento esistente
    const movDaModificare = props.movimentoDaModificare;

    // Se esiste, inizializziamo con i suoi dati; altrimenti usiamo i valori di default per un nuovo movimento
    const [importo, setImporto] = useState(movDaModificare ? movDaModificare.importo : "");
    const [soggetto, setSoggetto] = useState(movDaModificare ? movDaModificare.soggetto : "");
    const [descrizione, setDescrizione] = useState(movDaModificare ? (movDaModificare.descrizione || "") : "");
    const [dataMovimento, setDataMovimento] = useState(movDaModificare ? movDaModificare.data : ottieniDataOdierna()); 
    const [idMetodo, setIdMetodo] = useState(
        movDaModificare ? movDaModificare.id_metodo : (props.metodiPagamento && props.metodiPagamento.length > 0 ? props.metodiPagamento[0].id : "")
    );
    const [eu, setEU] = useState(movDaModificare ? movDaModificare.eu : false);// false = Uscita di default

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!importo || !soggetto) {
            alert("Inserisci almeno l'importo e il soggetto!");
            return;
        }

        const datiMovimento = {
            id: movDaModificare ? movDaModificare.id_movimento : null,
            codice_fiscale: props.codiceFiscale,
            importo: parseFloat(importo),
            soggetto: soggetto,
            descrizione: descrizione.trim() === "" ? null : descrizione,
            id_metodo: idMetodo ? parseInt(idMetodo) : null,
            data: dataMovimento, 
            eu: eu
        };


        // Scegliamo l'endpoint e il metodo HTTP in base alla modalità (Modifica vs Inserimento)
        //const endpoint = movDaModificare ? 'http://localhost:5001/api/modifica-movimento' : 'http://localhost:5001/api/aggiungi-movimento';
        const endpoint = movDaModificare ? '/api/modifica-movimento' : '/api/aggiungi-movimento';
        const metodoHttp = movDaModificare ? 'PUT' : 'POST';

        try {
            const risposta = await fetch(endpoint, {
                method: metodoHttp,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(datiMovimento)
            });
            const risultato = await risposta.json();

            if (risposta.ok && risultato.success) {
                alert(movDaModificare ? "Movimento modificato con successo!" : "Movimento registrato con successo!");
                if (props.onSuccess) {
                    props.onSuccess();
                }
            } else {
                alert(risultato.message || "Errore durante il salvataggio.");
            }
        } catch (errore) {
            console.error("Errore di connessione:", errore);
            alert("Impossibile contattare il server.");
        }
    };

    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
                <h2>{movDaModificare ? "Modifica Movimento" : "Inserisci Nuovo Movimento"}</h2>
                <form onSubmit={handleSubmit} style={styles.modalForm}>
                    
                    {/* Menu a tendina per Entrata / Uscita */}
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Tipo di movimento</label>
                        <select 
                            value={eu}
                            onChange={(e) => setEU(e.target.value === 'true')}
                            style={styles.modalInput}
                        >
                            <option value={false}>Uscita 🔴</option>
                            <option value={true}>Entrata 🟢</option>
                        </select>
                    </div>

                    <input 
                        type="number" 
                        step="0.01" 
                        placeholder="Importo (€)" 
                        value={importo}
                        onChange={(e) => setImporto(e.target.value)}
                        style={styles.modalInput}
                        required 
                    />

                    <input 
                        type="text" 
                        placeholder="Soggetto (es. Amazon, Amico...)" 
                        value={soggetto}
                        onChange={(e) => setSoggetto(e.target.value)}
                        style={styles.modalInput}
                        required 
                    />

                    <input 
                        type="text" 
                        placeholder="Descrizione (opzionale)" 
                        value={descrizione}
                        onChange={(e) => setDescrizione(e.target.value)}
                        style={styles.modalInput}
                    />

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Data movimento</label>
                        <input 
                            type="date" 
                            value={dataMovimento}
                            onChange={(e) => setDataMovimento(e.target.value)}
                            style={styles.modalInput}
                            required 
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Metodo di pagamento</label>
                        <select 
                            value={idMetodo}
                            onChange={(e) => setIdMetodo(e.target.value)}
                            style={styles.modalInput}
                        >
                            {props.metodiPagamento.map((metodo) => (
                                <option key={metodo.id} value={metodo.id}>
                                    {metodo.nome} {metodo.conto ? `(${metodo.conto})` : ''}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div style={styles.modalButtons}>
                        <button type="submit" style={styles.saveBtn}>{movDaModificare ? "Salva Modifiche" : "Salva"}</button>
                        <button type="button" onClick={props.onClose} style={styles.cancelBtn}>Annulla</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

const styles = {
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modalContent: {
        backgroundColor: '#1e293b',
        padding: '30px',
        borderRadius: '12px',
        width: '100%',
        maxWidth: '400px',
        color: '#ffffff',
        border: '1px solid #334155',
        boxShadow: '0 20px 25px rgba(0,0,0,0.5)',
        textAlign: 'center',
    },
    modalForm: {
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        marginTop: '20px',
    },
    inputGroup: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
    },
    label: {
        fontSize: '0.85rem',
        marginBottom: '4px',
        color: '#cbd5e1',
        fontWeight: '500',
    },
    modalInput: {
        padding: '12px',
        borderRadius: '6px',
        border: '1px solid #475569',
        backgroundColor: '#0f172a',
        color: '#ffffff',
        fontSize: '1rem',
        outline: 'none',
    },
    modalButtons: {
        display: 'flex',
        gap: '10px',
        marginTop: '10px',
    },
    saveBtn: {
        flex: 1,
        backgroundColor: '#22c55e',
        color: '#0f172a',
        border: 'none',
        padding: '12px',
        borderRadius: '6px',
        fontWeight: 'bold',
        cursor: 'pointer',
        fontSize: '1rem',
    },
    cancelBtn: {
        flex: 1,
        backgroundColor: '#ef4444',
        color: '#ffffff',
        border: 'none',
        padding: '12px',
        borderRadius: '6px',
        fontWeight: 'bold',
        cursor: 'pointer',
        fontSize: '1rem',
    }
};

export default NewMovementModal;
